module.exports = __webpack_public_path__ + "img/people29.1ef15604.png";